import React from "react";

import LayoutBlog from "../../layouts/LayoutBlog.jsx";
import MiniCardUser from "../../templates/blog/MiniCardUser.jsx";
import Posts from "../../templates/blog/Posts.jsx";

const BlogSite = () => {
	return (
		<LayoutBlog>
			<main className=" blogsite main__container">
				<Posts />
				<MiniCardUser />
			</main>
		</LayoutBlog>
	);
};

export default BlogSite;
